import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a3ae01d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "addAppQuestionPage" }

import { ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import { IconPlus, IconEdit, IconDelete } from "@arco-design/web-vue/es/icon";
import API from "@/api";
import {
  deleteAppResultUsingPost,
  getAppResultByAppIdUsingGet,
} from "@/api/appResultController";
import { dayjs } from "@arco-design/web-vue/es/_utils/date";
import AddAppResultModal from "@/views/app/components/AddAppResultModal.vue";

/**
 * 定义组件属性类型
 */
interface Props {
  appId: string;
  appVO: API.AppVO;
}

/**
 * 给组件指定初始值
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'AppResultModal',
  props: {
    appId: { default: () => "" },
    appVO: { default: () => null }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const visible = ref(false);
const openModal = () => {
  loadData();
  visible.value = true;
};

const closeModal = () => {
  visible.value = false;
};
__expose({
  openModal,
});
const tableColumns = [
  {
    title: "结果名称",
    dataIndex: "resultName",
    align: "center",
  },
  {
    title: "结果描述",
    dataIndex: "resultDesc",
    align: "center",
  },
  {
    title: "结果图片",
    slotName: "resultPic",
    align: "center",
  },
  {
    title: "结果",
    slotName: "result",
    align: "center",
  },
  {
    title: "创建时间",
    slotName: "createTime",
    align: "center",
  },
  {
    title: "更新时间",
    slotName: "updateTime",
    align: "center",
  },
  {
    title: "操作",
    slotName: "optional",
    align: "center",
  },
];
const tableData = ref();
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  const res = await getAppResultByAppIdUsingGet({
    appId: props.appId as any,
  });
  if (res.data.code === 200 && res.data.data) {
    tableData.value = res.data.data;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};
const addAppResultModalRef = ref();
const openAddAppResultModal = (id: any) => {
  addAppResultModalRef.value.openModal(id);
};
const handleDelete = async (id: any) => {
  const res = await deleteAppResultUsingPost({
    id,
  });
  if (res.data.code === 200 && res.data.data) {
    message.success("删除成功");
  } else {
    message.error("删除失败，" + res.data.message);
  }
  loadData();
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      onCancel: closeModal,
      footer: false,
      fullscreen: ""
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.appVO.appName), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openAddAppResultModal('')))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(IconPlus))
          ]),
          default: _withCtx(() => [
            _createTextVNode(" 添加结果 ")
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          columns: tableColumns,
          data: tableData.value,
          pagination: false,
          stripe: true
        }, {
          result: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(record.resultScore === null ? record.resultProp : record.resultScore), 1)
          ]),
          resultPic: _withCtx(({ record }) => [
            (record.resultPic)
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  width: "100",
                  src: record.resultPic,
                  alt: record.resultName
                }, null, 8, ["src", "alt"]))
              : _createCommentVNode("", true)
          ]),
          createTime: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
          ]),
          updateTime: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_unref(dayjs)(record.updateTime).format("YYYY-MM-DD HH:mm:ss")), 1)
          ]),
          optional: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (openAddAppResultModal(record.id))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(IconEdit))
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              status: "danger",
              onClick: ($event: any) => (handleDelete(record.id))
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(IconDelete))
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(AddAppResultModal, {
          ref_key: "addAppResultModalRef",
          ref: addAppResultModalRef,
          "app-id": props.appId,
          "app-type": props.appVO.appType as number,
          onUpdateData: loadData
        }, null, 8, ["app-id", "app-type"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})